import { render, staticRenderFns } from "./bind-job.vue?vue&type=template&id=28efb7eb&scoped=true"
import script from "./bind-job.vue?vue&type=script&lang=js"
export * from "./bind-job.vue?vue&type=script&lang=js"
import style0 from "./bind-job.vue?vue&type=style&index=0&id=28efb7eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28efb7eb",
  null
  
)

export default component.exports